import { ChartActionButton } from '../styles/components';
import { useT } from '../i18n';

/**
 * "Einbetten" affordance in a chart header, sitting immediately left of the
 * export menu. Built on the same ChartActionButton as that menu's trigger, so
 * the two read as one pair of controls rather than two near-identical buttons.
 *
 * Rendered only where an onEmbed handler exists, which is what keeps it out of
 * an embed itself — EmbedChart passes none, so an embedded chart cannot offer
 * an embed snippet for an embed.
 */
export function EmbedButton({ onClick }: { onClick: () => void }) {
  const m = useT();
  return (
    <ChartActionButton onClick={onClick} title={m.chart.embedChart} aria-label={m.chart.embedChart}>
      <span className="icon" data-icon="code" />
    </ChartActionButton>
  );
}
